import "bootstrap/dist/css/bootstrap.min.css";

import { Nav, Navbar, NavDropdown } from "react-bootstrap";
import { BiCheckShield, BiUser } from "react-icons/bi";

import { BsFillHouseDoorFill, BsGraphUpArrow } from "react-icons/bs";
import { Link } from "react-router-dom";

export const Menu = () => {
  return (
    <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark">
      <Navbar.Toggle aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse id="responsive-navbar-nav">
        <Nav variant="dark" className="mr-auto">
          <Link
            className="text-esat-100 hover:text-red-700 mt-2 sm:ml-[60px] mr-2"
            to="/esat/sigecap/"


          >
            {" "}
            <BsFillHouseDoorFill /> Home{" "}
          </Link>
          <NavDropdown title="Cursos" className="sm:hover:text-red-700 sm:mt-4">
            <Link className="hover:text-red-700 ml-4" to="/esat/sigecap/curso/disponiveis">
              Disponíveis
            </Link>
            <NavDropdown.Divider />
            <Link className="hover:text-red-700 ml-4" to="/esat/sigecap/curso/meuscursos">
              Meus Cursos
            </Link>
            <NavDropdown.Divider />
          </NavDropdown>       

          <NavDropdown
            title="Performance"
            className="sm:hover:text-red-700 sm:mt-4"
          >
            <Link
              className="hover:text-red-700 ml-4"
              to="/esat/sigecap/performance/visualizar"
            >
              Visualizar
            </Link>
            <NavDropdown.Divider />            
          </NavDropdown>
         {/*  <Link className="text-esat-100 hover:text-red-700 mt-2 mr-3" to="/">
            <BiSolidCertification />
            Certificado(s)
          </Link> */}
           <Link className="text-esat-100 hover:text-red-700 mt-2 mr-3" to="https://sesat1.sefaz.pb.gov.br/esat/trilhashomologacao" target="_blank">
              <BsGraphUpArrow />
              Trilhas de Aprendizagem
            </Link>
           <Link className="text-esat-100 hover:text-red-700 mt-2 mr-3" to="https://sesat1.sefaz.pb.gov.br/esat/perfil_atualizacao" target="_blank">
              <BiUser />
             Atualização cadastral
            </Link>
              <Link className="text-esat-100 hover:text-red-700 mt-2 mr-3" to="/esat/sigecap/autorizar">
              <BiCheckShield  />
              Autorizar Inscrição
            </Link>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};
